import sessionService from 'web-client/utils/session'

function isAuthenticated() {
  return sessionService.hasBearerToken()
}

export default isAuthenticated
